import type { VoidFunctionComponent } from 'react';
import DashboardActionCards from './DashboardActionCards';
import ReportsCallToAction from './ReportsCallToAction';

const ReportsDashboard: VoidFunctionComponent = () => (
  <>
    <ReportsCallToAction />
    <div className="container reports-dashboard-contents">
      <div className="dashboard-grid">
        <DashboardActionCards />
      </div>
    </div>
  </>
);

export default ReportsDashboard;
